

















import { Component, Vue } from 'vue-property-decorator';
import ThingEntity from '@/entities/ThingEntity';
import DiggingDialog from '@/components/DiggingDialog.vue';
@Component({
    components: {DiggingDialog},
})
export default class Map extends Vue {

    public $refs!: {
        diggingDialog: DiggingDialog,
    };

    public snackbar: boolean = false;
    public snackbarMessage: string = '';

    // noinspection JSUnusedGlobalSymbols
    public mounted(): void {
        this.$locator.gamePlayService.init('main-map-container', this.notify, this.clickThing);
    }

    private notify(message: string): void {
        this.snackbarMessage = message;
        this.snackbar = true;
    }

    private clickThing(thing: ThingEntity) {
        this.$refs.diggingDialog.open(thing);
    }
}
